export default {
  "1a": {
    description: "Ik kan uitleggen wat een 'persoonsvorm' is.",
    pageExists: true
  },
  "1b": {
    description: "Ik kan de persoonsvorm enkelvoud en meervoud herkennen.",
    pageExists: true
  },
  "1c": {
    description: "Ik kan de persoonsvorm enkelvoud en meervoud vertalen.",
    pageExists: true
  },
  "1d": {
    description: "Ik kan uitleggen wat een 'infinitivus' is.",
    pageExists: true
  },
  "1e": { description: "Ik kan de infinitivus herkennen.", pageExists: true },
  "1f": { description: "Ik kan de infinitivus vertalen.", pageExists: true },
  "1g": {
    description: "Ik kan de vormen van esse herkennen en vertalen.",
    pageExists: true
  },
  "1h": {
    description: "Ik kan uitleggen wat een 'zelfstandig naamwoord' is.",
    pageExists: true
  },
  "1i": {
    description: "Ik kan uitleggen wat een 'onderwerp' is.",
    pageExists: true
  },
  "1j": {
    description: "Ik kan uitleggen wat een 'lijdend voorwerp' is.",
    pageExists: true
  },
  "1k": {
    description: "Ik kan uitleggen wat een 'naamval' is.",
    pageExists: true
  },
  "1l": {
    description: "Ik kan uitleggen welke functie de nominativus heeft.",
    pageExists: true
  },
  "1m": {
    description: "Ik kan uitleggen welke functie de accusativus heeft.",
    pageExists: true
  },
  "1n": {
    description: "Ik kan een zelfstandig naamwoord als nominativus vertalen.",
    pageExists: true
  },
  "1o": {
    description: "Ik kan een zelfstandig naamwoord als accusativus vertalen.",
    pageExists: true
  },
  "1p": {
    description: "Ik kan uitleggen wat 'getal' inhoudt.",
    pageExists: true
  },
  "1q": {
    description:
      "Ik kan op basis van de woordenlijstvorm het rijtje voor een zelfstandig naamwoord bepalen.",
    pageExists: true
  },
  "1r": {
    description:
      "Ik kan op basis van de woordenlijstvorm de stam van een zelfstandig naamwoord bepalen.",
    pageExists: true
  },
  "1s": {
    description: "Ik kan zelfstandige naamwoorden benoemen.",
    pageExists: true
  },
  "1t": {
    description: "Ik kan zelfstandige naamwoorden vertalen.",
    pageExists: false
  },
  "2a": {
    description: "Ik kan uitleggen wat een 'meewerkend voorwerp' is.",
    pageExists: true
  },
  "2b": {
    description: "Ik kan uitleggen welke functie de dativus heeft.",
    pageExists: true
  },
  "2c": {
    description:
      "Ik kan aan de hand van de persoonsvorm in een zin voorspellen welke naamvallen ik verwacht.",
    pageExists: true
  },
  "2d": {
    description: "Ik kan een zelfstandig naamwoord als dativus vertalen.",
    pageExists: true
  },
  "2e": {
    description: "Ik kan zelfstandige naamwoorden benoemen.",
    pageExists: true
  },
  "2f": {
    description: "Ik kan zelfstandige naamwoorden vertalen.",
    pageExists: false
  },
  "2g": {
    description: "Ik kan uitleggen wat een 'persoonlijk voornaamwoord' is.",
    pageExists: true
  },
  "2h": {
    description: "Ik kan de persoonlijke voornaamwoorden benoemen.",
    pageExists: true
  },
  "2i": {
    description: "Ik kan de persoonlijke voornaamwoorden vertalen.",
    pageExists: false
  },
  "3a": {
    description: "Ik kan uitleggen wat een 'bijwoord' is.",
    pageExists: true
  },
  "3b": {
    description: "Ik kan uitleggen wat een 'bijwoordelijke bepaling' is.",
    pageExists: true
  },
  "3c": {
    description: "Ik kan uitleggen welke functies de ablativus heeft.",
    pageExists: true
  },
  "3d": {
    description: "Ik kan een zelfstandig naamwoord als ablativus vertalen.",
    pageExists: true
  },
  "3e": {
    description: "Ik kan zelfstandige naamwoorden benoemen.",
    pageExists: true
  },
  "3f": {
    description: "Ik kan zelfstandige naamwoorden vertalen.",
    pageExists: false
  },
  "3g": {
    description: "Ik kan uitleggen wat een 'voorzetsel' is.",
    pageExists: true
  },
  "3h": {
    description:
      "Ik kan uitleggen welke naamvallen bij een voorzetsel gebruikt kunnen worden.",
    pageExists: true
  },
  "4a": {
    description: "Ik kan uitleggen wat een 'bijvoeglijke bepaling' is.",
    pageExists: true
  },
  "4b": {
    description: "Ik kan uitleggen welke functie de genitivus heeft.",
    pageExists: true
  },
  "4c": {
    description: "Ik kan een zelfstandig naamwoord als genitivus vertalen.",
    pageExists: true
  },
  "4d": {
    description: "Ik kan zelfstandige naamwoorden benoemen.",
    pageExists: true
  },
  "4e": {
    description: "Ik kan zelfstandige naamwoorden vertalen.",
    pageExists: false
  },
  "5a": {
    description:
      "Ik kan op basis van de woordenlijstvorm het rijtje voor een zelfstandig naamwoord bepalen.",
    pageExists: true
  },
  "5b": {
    description:
      "Ik kan op basis van de woordenlijstvorm de stam van een zelfstandig naamwoord bepalen.",
    pageExists: true
  },
  "5c": {
    description: "Ik kan zelfstandige naamwoorden benoemen.",
    pageExists: true
  },
  "5d": {
    description: "Ik kan zelfstandige naamwoorden vertalen.",
    pageExists: false
  },
  "6a": {
    description:
      "Ik kan voor een werkwoord bepalen welke aanvullingen ik erbij verwacht. ",
    pageExists: false
  },
  "6b": {
    description:
      "Ik kan uitleggen wat een 'naamwoordelijk deel van het gezegde' is.",
    pageExists: false
  },
  "6c": {
    description: "Ik kan uitleggen wat een 'kernzin' is.",
    pageExists: false
  },
  "6d": {
    description:
      "Ik kan het verschil tussen 'verplicht' en 'niet-verplicht' gebruik van een naamval uitleggen.",
    pageExists: false
  },
  "6e": {
    description: "Ik kan uitleggen wat de functies van elke naamval zijn.",
    pageExists: false
  },
  "8a": {
    description: "Ik kan de persoonsuitgangen herkennen.",
    pageExists: true
  },
  "8b": {
    description: "Ik kan uitleggen hoe de praesensstam wordt gevormd.",
    pageExists: true
  },
  "8c": {
    description:
      "Ik kan voor een werkwoord bepalen in welke stamgroep het hoort.",
    pageExists: true
  },
  "8d": {
    description: "Ik kan uitleggen wat een 'bindvocaal' is.",
    pageExists: false
  },
  "8e": {
    description:
      "Ik kan in een werkwoordsvorm de stam, bindvocaal en persoonsuitgang aangeven.",
    pageExists: false
  },
  "8f": { description: "Ik kan werkwoorden benoemen.", pageExists: false },
  "8g": { description: "Ik kan werkwoorden vertalen.", pageExists: false },
  "9a": {
    description: "Ik kan de vormen van esse en posse benoemen.",
    pageExists: false
  },
  "9b": {
    description: "Ik kan de vormen van esse en posse vertalen.",
    pageExists: false
  },
  "9c": {
    description: "Ik kan uitleggen wat een 'imperativus' is.",
    pageExists: false
  },
  "9d": {
    description: "Ik kan vormen in de imperativus benoemen.",
    pageExists: false
  },
  "9e": {
    description: "Ik kan vormen in de imperativus vertalen.",
    pageExists: false
  },
  "9f": {
    description: "Ik kan uitleggen wat een 'vocativus' is.",
    pageExists: false
  },
  "9g": {
    description: "Ik kan vormen in de vocativus benoemen.",
    pageExists: false
  },
  "9h": {
    description: "Ik kan vormen in de vocativus vertalen.",
    pageExists: false
  },
  "10a": {
    description: "Ik kan uitleggen wat het 'praesens' is.",
    pageExists: false
  },
  "10b": {
    description: "Ik kan uitleggen wat het 'imperfectum' is.",
    pageExists: false
  },
  "10c": {
    description: "Ik kan uitleggen wat het 'perfectum' is.",
    pageExists: false
  },
  "10d": {
    description:
      "Ik kan uitleggen wat het verschil qua gebruik is tussen het imperfectum en het perfectum.",
    pageExists: false
  },
  "10e": {
    description: "Ik kan uitleggen wat 'kenletters' zijn.",
    pageExists: true
  },
  "10f": {
    description: "Ik kan de kenletters van het imperfectum herkennen.",
    pageExists: true
  },
  "10g": {
    description: "Ik kan de persoonsuitgangen van het perfectum herkennen.",
    pageExists: true
  },
  "10h": { description: "Ik kan werkwoorden benoemen.", pageExists: false },
  "10i": { description: "Ik kan werkwoorden vertalen.", pageExists: false },
  "10j": {
    description: "Ik kan de vormen van esse en posse benoemen.",
    pageExists: false
  },
  "10k": {
    description: "Ik kan de vormen van esse en posse vertalen.",
    pageExists: false
  },
  "11a": {
    description: "Ik kan uitleggen wat het 'plusquamperfectum' is.",
    pageExists: false
  },
  "11b": {
    description: "Ik kan de kenletters van het plusquamperfectum herkennen.",
    pageExists: true
  },
  "11c": { description: "Ik kan werkwoorden benoemen.", pageExists: false },
  "11d": { description: "Ik kan werkwoorden vertalen.", pageExists: false },
  "12a": {
    description: "Ik kan uitleggen waarvoor de praesensstam wordt gebruikt.",
    pageExists: false
  },
  "12b": {
    description: "Ik kan uitleggen waarvoor de perfectumstam wordt gebruikt.",
    pageExists: false
  },
  "12c": {
    description: "Ik kan uitleggen hoe de perfectumstam wordt gevormd",
    pageExists: true
  },
  "12d": {
    description:
      "Ik kan in een werkwoordsvorm de stam, kenletters, bindvocalen en persoonsuitgang aangeven.",
    pageExists: false
  },
  "12e": { description: "Ik kan werkwoorden benoemen.", pageExists: false },
  "12f": { description: "Ik kan werkwoorden vertalen.", pageExists: false },
  "15a": {
    description:
      "Ik kan op basis van de woordenlijstvorm het geslacht van een zelfstandig naamwoord bepalen.",
    pageExists: true
  },
  "15b": {
    description: "Ik kan uitleggen wat een 'bijvoeglijk naamwoord' is.",
    pageExists: true
  },
  "15c": {
    description: "Ik kan uitleggen wat 'congruentie' is.",
    pageExists: true
  },
  "15d": {
    description:
      "Ik kan op basis van de woordenlijstvorm de stam van een bijvoeglijk naamwoord bepalen.",
    pageExists: true
  },
  "15e": {
    description: "Ik kan bijvoeglijke naamwoorden benoemen.",
    pageExists: true
  },
  "15f": {
    description:
      "Ik kan combinaties van een zelfstandig en bijvoeglijk naamwoord benoemen.",
    pageExists: true
  },
  "16a": {
    description:
      "Ik kan op basis van de woordenlijstvorm het rijtje voor een bijvoeglijk naamwoord bepalen.",
    pageExists: true
  },
  "16b": {
    description:
      "Ik kan op basis van de woordenlijstvorm de stam voor een bijvoeglijk naamwoord bepalen.",
    pageExists: true
  },
  "16c": {
    description: "Ik kan bijvoeglijke naamwoorden benoemen.",
    pageExists: true
  },
  "16d": {
    description:
      "Ik kan bepalen met welk zelfstandig naamwoord een bijvoeglijk naamwoord congrueert.",
    pageExists: true
  },
  "17a": { description: "Ik kan een bijwoord herkennen.", pageExists: true },
  "17b": { description: "Ik kan een bijwoord vertalen.", pageExists: true },
  "18a": {
    description: "Ik kan uitleggen wat de trappen van vergelijking zijn.",
    pageExists: true
  },
  "18b": {
    description: "Ik kan uitleggen wat een 'comparativus' is.",
    pageExists: true
  },
  "18c": {
    description: "Ik kan uitleggen hoe de comparativus wordt gevormd.",
    pageExists: true
  },
  "18d": {
    description: "Ik kan vormen in de comparativus benoemen.",
    pageExists: true
  },
  "18e": {
    description:
      "Ik kan uitleggen op welke manieren een comparativus vertaald kan worden.",
    pageExists: true
  },
  "18f": {
    description: "Ik kan uitleggen wat een 'superlativus' is.",
    pageExists: true
  },
  "18g": {
    description: "Ik kan uitleggen hoe de superlativus wordt gevormd.",
    pageExists: true
  },
  "18h": {
    description: "Ik kan vormen in de superlativus benoemen.",
    pageExists: true
  },
  "18i": {
    description:
      "Ik kan uitleggen op welke manieren een superlativus vertaald kan worden.",
    pageExists: true
  },
  "18j": {
    description: "Ik kan de onregelmatige trappen van vergelijking vertalen.",
    pageExists: true
  },
  "22a": {
    description: "Ik kan vraagwoorden en vragende bijwoorden vertalen.",
    pageExists: true
  },
  "22b": {
    description:
      "Ik kan het verschil tussen 'zelfstandig gebruik' en 'bijvoeglijk gebruik' uitleggen.",
    pageExists: true
  },
  "22c": {
    description:
      "Ik kan zelfstandig gebruikte vragende voornaamwoorden benoemen.",
    pageExists: true
  },
  "22d": {
    description:
      "Ik kan zelfstandig gebruikte vragende voornaamwoorden vertalen.",
    pageExists: true
  },
  "22e": {
    description:
      "Ik kan bijvoeglijk gebruikte vragende voornaamwoorden benoemen.",
    pageExists: true
  },
  "22f": {
    description:
      "Ik kan bijvoeglijk gebruikte vragende voornaamwoorden vertalen.",
    pageExists: true
  },
  "23a": {
    description: "Ik kan uitleggen wat een 'samengestelde zin' is.",
    pageExists: true
  },
  "23b": {
    description: "Ik kan uitleggen wat een 'hoofdzin' is.",
    pageExists: true
  },
  "23c": {
    description: "Ik kan nevenschikkende voegwoorden herkennen.",
    pageExists: true
  },
  "23d": {
    description: "Ik kan uitleggen wat een 'bijzin' is.",
    pageExists: true
  },
  "23e": {
    description: "Ik kan onderschikkende voegwoorden herkennen.",
    pageExists: true
  },
  "23f": {
    description: "Ik kan een samengestelde zin opdelen in losse deelzinnen.",
    pageExists: true
  },
  "24a": {
    description: "Ik kan uitleggen wat een 'betrekkelijke bijzin' is.",
    pageExists: true
  },
  "24b": {
    description: "Ik kan uitleggen wat een 'betrekkelijk voornaamwoord' is.",
    pageExists: true
  },
  "24c": {
    description: "Ik kan uitleggen wat een 'antecedent' is.",
    pageExists: true
  },
  "24d": {
    description: "Ik kan betrekkelijke voornaamwoorden benoemen.",
    pageExists: true
  },
  "24e": {
    description: "Ik kan het antecedent van een betrekkelijke bijzin aangeven.",
    pageExists: false
  },
  "24f": {
    description: "Ik kan in een zin de betrekkelijke bijzin aangeven.",
    pageExists: false
  },
  "24g": {
    description: "Ik kan in een zin de betrekkelijke bijzin vertalen.",
    pageExists: false
  },
  "25a": {
    description:
      "Ik kan het verschil tussen 'directe rede' en 'indirecte rede' uitleggen.",
    pageExists: true
  },
  "25b": {
    description: "Ik kan uitleggen wat een 'aci' is.",
    pageExists: true
  },
  "25c": {
    description:
      "Ik kan uitleggen in welke omstandigheden je een aci in de zin verwacht.",
    pageExists: true
  },
  "25d": {
    description: "Ik kan in een zin de aci aangeven.",
    pageExists: true
  },
  "25e": {
    description: "Ik kan uitleggen wat 'gelijktijdig vertalen' inhoudt.",
    pageExists: true
  },
  "25f": { description: "Ik kan een aci vertalen.", pageExists: true },
  "25g": {
    description: "Ik kan persoonlijke voornaamwoorden binnen een aci vertalen.",
    pageExists: false
  },
  "26a": {
    description:
      "Ik kan uitleggen hoe het infinitivus perfectum wordt gevormd.",
    pageExists: false
  },
  "26b": {
    description: "Ik kan een losse infinitivus perfectum vertalen.",
    pageExists: false
  },
  "26c": {
    description: "Ik kan uitleggen wat 'voortijdig vertalen' inhoudt.",
    pageExists: true
  },
  "26d": { description: "Ik kan een aci vertalen.", pageExists: true },
  "29a": {
    description: "Ik kan uitleggen waarvoor de praesensstam wordt gebruikt.",
    pageExists: false
  },
  "29b": {
    description: "Ik kan uitleggen waarvoor de perfectumstam wordt gebruikt.",
    pageExists: false
  },
  "29c": {
    description: "Ik kan de kenletters van het futurum herkennen.",
    pageExists: true
  },
  "29d": {
    description: "Ik kan de kenletters van het futurum exactum herkennen.",
    pageExists: true
  },
  "29e": {
    description:
      "Ik kan in een werkwoordsvorm de stam, kenletters, bindvocalen en persoonsuitgang aangeven.",
    pageExists: false
  },
  "29f": { description: "Ik kan werkwoorden benoemen.", pageExists: false },
  "29g": { description: "Ik kan werkwoorden vertalen.", pageExists: true },
  "29h": {
    description: "Ik kan de vormen van esse en posse benoemen.",
    pageExists: false
  },
  "29i": {
    description: "Ik kan de vormen van esse en posse vertalen.",
    pageExists: false
  },
  "30a": {
    description:
      "Ik kan de verschillen uitleggen tussen een actieve en een passieve zin.",
    pageExists: false
  },
  "30b": {
    description: "Ik kan de persoonsuitgangen van het passivum herkennen.",
    pageExists: true
  },
  "30c": { description: "Ik kan werkwoorden benoemen.", pageExists: false },
  "30d": { description: "Ik kan werkwoorden vertalen.", pageExists: false },
  "30e": {
    description:
      "Ik kan uitleggen op welke twee manieren de handelende persoon wordt aangegeven.",
    pageExists: false
  },
  "31a": {
    description: "Ik kan uitleggen hoe het ppp wordt gevormd.",
    pageExists: true
  },
  "31b": {
    description: "Ik kan vormen van het ppp benoemen.",
    pageExists: false
  },
  "31c": { description: "Ik kan een los ppp vertalen.", pageExists: false },
  "31d": { description: "Ik kan werkwoorden benoemen.", pageExists: false },
  "31e": { description: "Ik kan werkwoorden vertalen.", pageExists: false },
  "32a": {
    description:
      "Ik kan de onregelmatige vormen van velle, nolle en malle benoemen.",
    pageExists: false
  },
  "32b": {
    description:
      "Ik kan de onregelmatige vormen van velle, nolle en malle vertalen.",
    pageExists: false
  },
  "32c": {
    description: "Ik kan de onregelmatige vormen van ferre en ire benoemen.",
    pageExists: false
  },
  "32d": {
    description: "Ik kan de onregelmatige vormen van ferre en ire vertalen.",
    pageExists: false
  },
  "32e": {
    description: "Ik kan samengestelde vormen van ferre en ire benoemen.",
    pageExists: false
  },
  "32f": {
    description: "Ik kan samengestelde vormen van ferre en ire vertalen.",
    pageExists: false
  },
  "33a": {
    description:
      "Ik kan uitleggen hoe de infinitivus praesens passief wordt gevormd.",
    pageExists: true
  },
  "33b": {
    description: "Ik kan een losse infinitivus praesens passief vertalen.",
    pageExists: true
  },
  "33c": {
    description:
      "Ik kan uitleggen hoe de infinitivus perfectum passief wordt gevormd.",
    pageExists: true
  },
  "33d": {
    description: "Ik kan een losse infinitivus perfectum passief vertalen.",
    pageExists: true
  },
  "33e": {
    description: "Ik kan uitleggen hoe het pfa wordt gevormd.",
    pageExists: true
  },
  "33f": {
    description:
      "Ik kan uitleggen hoe de infinitivus futurum actief wordt gevormd.",
    pageExists: true
  },
  "33g": {
    description: "Ik kan een losse infinitivus futurum actief vertalen.",
    pageExists: true
  },
  "33h": {
    description: "Ik kan uitleggen wat 'natijdig vertalen' inhoudt.",
    pageExists: true
  },
  "33i": { description: "Ik kan een aci vertalen.", pageExists: true },
  "36a": {
    description:
      "Ik kan op basis van de woordenlijstvorm het rijtje voor een zelfstandig naamwoord bepalen.",
    pageExists: true
  },
  "36b": {
    description:
      "Ik kan op basis van de woordenlijstvorm de stam van een zelfstandig naamwoord bepalen.",
    pageExists: true
  },
  "36c": {
    description:
      "Ik kan op basis van de woordenlijstvorm het geslacht van een zelfstandig naamwoord bepalen.",
    pageExists: true
  },
  "36d": {
    description: "Ik kan zelfstandige naamwoorden benoemen.",
    pageExists: true
  },
  "36e": {
    description: "Ik kan zelfstandige naamwoorden vertalen.",
    pageExists: false
  },
  "37a": {
    description: "Ik kan uitleggen wat een 'dubbelverbonden bepaling' is.",
    pageExists: true
  },
  "37b": {
    description: "Ik kan een bijvoeglijk naamwoord bijvoeglijk vertalen.",
    pageExists: true
  },
  "37c": {
    description: "Ik kan een bijvoeglijk naamwoord dubbelverbonden vertalen.",
    pageExists: true
  },
  "37d": {
    description:
      "Ik kan het verschil tussen 'zelfstandig gebruik' en 'bijvoeglijk gebruik' uitleggen.",
    pageExists: true
  },
  "37e": {
    description: "Ik kan een bijvoeglijk naamwoord zelfstandig vertalen.",
    pageExists: true
  },
  "38a": {
    description: "Ik kan uitleggen hoe het ppa wordt gevormd.",
    pageExists: true
  },
  "38b": {
    description: "Ik kan vormen van het ppa benoemen.",
    pageExists: true
  },
  "38c": { description: "Ik kan een los ppa vertalen.", pageExists: true },
  "38d": {
    description: "Ik kan een ppa in zinsverband vertalen.",
    pageExists: true
  },
  "38e": {
    description: "Ik kan uitleggen wat 'gelijktijdig vertalen' inhoudt.",
    pageExists: true
  },
  "38f": {
    description: "Ik kan in een zin de participiumwoordgroep aangeven.",
    pageExists: true
  },
  "38g": {
    description: "Ik kan een ppa binnen een participiumwoordgroep vertalen.",
    pageExists: false
  },
  "39a": {
    description: "Ik kan uitleggen wat 'voortijdig vertalen' inhoudt.",
    pageExists: false
  },
  "39b": {
    description:
      "Ik kan het verschil in vertaling tussen een ppa en een ppp uitleggen.",
    pageExists: true
  },
  "39c": {
    description: "Ik kan participia binnen een participiumwoordgroep vertalen.",
    pageExists: true
  },
  "40a": {
    description: "Ik kan uitleggen wat een 'aanwijzend voornaamwoord' is.",
    pageExists: false
  },
  "40b": {
    description:
      "Ik kan het verschil tussen 'zelfstandig gebruik' en 'bijvoeglijk gebruik' uitleggen.",
    pageExists: false
  },
  "40c": {
    description: "Ik kan vormen van het aanwijzend voornaamwoord benoemen.",
    pageExists: false
  },
  "40d": {
    description:
      "Ik kan vormen van het aanwijzend voornaamwoord bijvoeglijk vertalen.",
    pageExists: false
  },
  "40e": {
    description:
      "Ik kan vormen van het aanwijzend voornaamwoord zelfstandig vertalen.",
    pageExists: false
  },
  "40f": {
    description:
      "Ik kan het verschil in betekenis tussen ille en iste uitleggen.",
    pageExists: false
  },
  "40g": {
    description: "Ik kan vormen van het verwijzend voornaamwoord benoemen.",
    pageExists: false
  },
  "40h": {
    description:
      "Ik kan vormen van het verwijzend voornaamwoord bijvoeglijk vertalen.",
    pageExists: false
  },
  "40i": {
    description:
      "Ik kan vormen van het verwijzend voornaamwoord zelfstandig vertalen.",
    pageExists: false
  },
  "40j": {
    description: "Ik kan vormen van het bepalend voornaamwoord benoemen.",
    pageExists: false
  },
  "40k": {
    description: "Ik kan vormen van het bepalend voornaamwoord vertalen.",
    pageExists: false
  },
  "43a": {
    description: "Ik kan de kenletters van de conjunctivus praesens herkennen.",
    pageExists: false
  },
  "43b": { description: "Ik kan werkwoorden benoemen.", pageExists: false },
  "43c": { description: "Ik kan werkwoorden vertalen.", pageExists: false },
  "43d": {
    description: "Ik kan de vormen van esse en posse benoemen.",
    pageExists: false
  },
  "43e": {
    description: "Ik kan de vormen van esse en posse vertalen.",
    pageExists: false
  },
  "43f": {
    description:
      "Ik kan uitleggen op welke zes manieren een conjunctivus praesens in de hoofdzin kan worden vertaald.",
    pageExists: false
  },
  "43g": {
    description:
      "Ik kan in een zin de meest passende vertaling van de conjunctivus praesens bepalen.",
    pageExists: false
  },
  "44a": {
    description:
      "Ik kan de kenletters van de conjunctivus imperfectum herkennen.",
    pageExists: false
  },
  "44b": {
    description:
      "Ik kan de kenletters van de conjunctivus perfectum actief herkennen.",
    pageExists: false
  },
  "44c": {
    description:
      "Ik kan de kenletters van de conjunctivus plusquamperfectum actief herkennen.",
    pageExists: false
  },
  "44d": { description: "Ik kan werkwoorden benoemen.", pageExists: false },
  "44e": { description: "Ik kan werkwoorden vertalen.", pageExists: false },
  "44f": {
    description: "Ik kan de vormen van esse en posse benoemen.",
    pageExists: false
  },
  "44g": {
    description: "Ik kan de vormen van esse en posse vertalen.",
    pageExists: false
  },
  "44h": {
    description:
      "Ik kan het verschil tussen een 'verplichte' en 'niet-verplichte' conjunctivus uitleggen.",
    pageExists: false
  },
  "44i": {
    description:
      "Ik kan het verschil tussen een 'directe vraag' en een 'indirecte vraag' uitleggen.",
    pageExists: false
  },
  "44j": {
    description: "Ik kan een indirecte vraag herkennen.",
    pageExists: false
  },
  "44k": {
    description: "Ik kan een conjunctivus in een indirecte vraag vertalen.",
    pageExists: false
  },
  "44l": {
    description:
      "Ik kan uitleggen hoe de vertaling van cum en ut wordt beïnvloed door de persoonsvorm die erbij hoort.",
    pageExists: false
  },
  "44m": {
    description:
      "Ik kan cum, ut en ne in combinatie met een conjunctivus vertalen.",
    pageExists: false
  },
  "45a": {
    description: "Ik kan uitleggen wat een 'irrealis' is.",
    pageExists: false
  },
  "45b": {
    description: "Ik kan een conjunctivus irrealis herkennen.",
    pageExists: false
  },
  "45c": {
    description:
      "Ik kan bij een irrealis aangeven of het betrekking heeft op het heden of het verleden.",
    pageExists: false
  },
  "45d": {
    description: "Ik kan een conjunctivus irrealis vertalen.",
    pageExists: false
  },
  "45e": {
    description:
      "Ik kan uitleggen hoe een conjunctivus in een betrekkelijke bijzin vertaald moet worden.",
    pageExists: false
  },
  "45f": {
    description:
      "Ik kan een conjunctivus in een betrekkelijke bijzin vertalen.",
    pageExists: false
  },
  "45g": {
    description:
      "Ik kan bij een conjunctivusvorm aangeven hoe deze is gebruikt.",
    pageExists: false
  },
  "46a": {
    description: "Ik kan uitleggen wat een 'onbepaald voornaamwoord' is.",
    pageExists: false
  },
  "46b": {
    description: "Ik kan onbepaalde voornaamwoorden benoemen.",
    pageExists: false
  },
  "46c": {
    description:
      "Ik kan het verschil tussen 'zelfstandig gebruik' en 'bijvoeglijk gebruik' uitleggen.",
    pageExists: false
  },
  "46d": {
    description: "Ik kan onbepaalde voornaamwoorden zelfstandig vertalen.",
    pageExists: false
  },
  "46e": {
    description: "Ik kan onbepaalde voornaamwoorden bijvoeglijk vertalen.",
    pageExists: false
  },
  "50a": {
    description: "Ik kan uitleggen wat een 'deponens' is.",
    pageExists: false
  },
  "50b": {
    description:
      "Ik kan op basis van de woordenlijstvorm bepalen of een werkwoord een deponens is.",
    pageExists: false
  },
  "50c": { description: "Ik kan deponensvormen vertalen.", pageExists: false },
  "50d": {
    description: "Ik kan uitleggen wat een 'semi-deponens' is.",
    pageExists: false
  },
  "50e": {
    description: "Ik kan semi-deponensvormen vertalen.",
    pageExists: false
  },
  "51a": {
    description:
      "Ik kan uitleggen hoe het ppp van een deponens vertaald moet worden.",
    pageExists: false
  },
  "51b": {
    description: "Ik kan participia binnen een participiumwoordgroep vertalen.",
    pageExists: false
  },
  "52a": {
    description: "Ik kan uitleggen wat een 'ablativus absolutus' is.",
    pageExists: false
  },
  "52b": {
    description: "Ik kan in een zin de ablativus absolutus aangeven.",
    pageExists: false
  },
  "52c": {
    description: "Ik kan een ablativus absolutus met een ppa vertalen.",
    pageExists: false
  },
  "52d": {
    description: "Ik kan een ablativus absolutus met een ppp vertalen.",
    pageExists: false
  },
  "54a": {
    description: "Ik kan uitleggen wat een 'gerundium' is.",
    pageExists: false
  },
  "54b": {
    description: "Ik kan vormen van het gerundium benoemen.",
    pageExists: false
  },
  "54c": {
    description: "Ik kan in een zin de gerundiumwoordgroep aangeven.",
    pageExists: false
  },
  "54d": {
    description: "Ik kan een gerundium(woordgroep) vertalen.",
    pageExists: false
  },
  "54e": {
    description: "Ik kan uitleggen wat een 'gerundivum' is.",
    pageExists: false
  },
  "54f": {
    description:
      "Ik kan uitleggen wat het verschil is tussen een gerundium en gerundivum.",
    pageExists: false
  },
  "54g": {
    description: "Ik kan vormen van het gerundivum benoemen.",
    pageExists: false
  },
  "54h": {
    description: "Ik kan een gerundivum zonder esse vertalen.",
    pageExists: false
  },
  "54i": {
    description: "Ik kan een gerundivum van verplichting (met esse) vertalen.",
    pageExists: false
  },
  "54j": {
    description:
      "Ik kan uitleggen hoe de handelende persoon bij een gerundivum van verplichting wordt aangegeven.",
    pageExists: false
  }
};



// WEBPACK FOOTER //
// ./src/data/leerdoelen-latijn.js